import React from "react";
import InformTable from "../Components/InformTable";
import { HistoryAction } from "../HistoryActionModel";
import { buildModifiedTableData } from "../utils/historyActionHelpers";

const formatValue = (property: string, value: any): string | null => {
    if (value === null || value === undefined) return null;
    return String(value);
};

export const FeatureUpdated: React.FC<{ action: HistoryAction }> = ({ action }) => {
    const { dataOld, dataNew } = buildModifiedTableData(action.Changes, formatValue);

    return (
        <div className="inform_panel">
            <InformTable data={dataOld} label="Old Version" />
            <InformTable data={dataNew} label="New Version" />
        </div>
    );
};
